import React, { JSX } from "react";
import { type BoxProps, TypographyProps } from "@mui/material";
import { Container, Text } from "./BrandLink.styled";
import { SvgIconProps } from "@mui/material/SvgIcon";
import { colors } from "src/styles/theme";

export type CTATextProps = {
  icon?: (props: SvgIconProps) => JSX.Element;
  iconPosition?: "left" | "right";
  typographyProps?: TypographyProps;
} & React.ComponentProps<typeof Container>;

export const BrandLink: React.FC<CTATextProps> = (props): JSX.Element => {
  const {
    icon: IconComponent,
    iconPosition = "left",
    typographyProps,
    children,
    ...rest
  } = props;
  return (
    <Container {...rest}>
      <Text
        variant="v2_special"
        {...typographyProps}
        sx={{
          fontSize: "18px",

          lineHeight: 1.1,

          display: "inline-flex",
          alignItems: "center",

          fontFamily: "Guton",
          color: colors.text.v2,

          ...typographyProps?.sx,
        }}
      >
        {iconPosition === "left" &&
          IconComponent?.({
            className: "left",
          })}
        {children}
        {iconPosition === "right" &&
          IconComponent?.({
            className: "right",
          })}
      </Text>
    </Container>
  );
};
